import { useMemo } from 'react';
import { CheckIcon, XIcon } from 'lucide-react';

import { PasswordPolicyRules } from '@worldathletics/utilities';

import './password-rules.scss';

type PasswordRulesProps = {
  password: string;
};

function PasswordRules({ password }: PasswordRulesProps) {
  const results = useMemo(
    () =>
      PasswordPolicyRules.map(rule => ({
        ...rule,
        isValid: rule.test(password),
      })),
    [password],
  );

  return (
    <ul className="password-rules" aria-label="Password requirements">
      {results.map(rule => (
        <li
          key={rule.id}
          className={
            'password-rules__item' +
            (rule.isValid ? ' password-rules__item--valid' : ' password-rules__item--invalid')
          }
        >
          {rule.isValid ? (
            <CheckIcon size={14} aria-hidden="true" />
          ) : (
            <XIcon size={14} aria-hidden="true" />
          )}
          <span>{rule.label}</span>
        </li>
      ))}
    </ul>
  );
}

export { PasswordRules };
